// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_2jBjV){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_2I3DX .dualColumn_1vSa4{display:flex;align-content:space-between}.nsAddressForm_2I3DX .dualColumn_1vSa4 .firstCol_2pWdy{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_2jBjV",
	"nsAddressForm": "nsAddressForm_2I3DX",
	"dualColumn": "dualColumn_1vSa4",
	"firstCol": "firstCol_2pWdy"
};
module.exports = exports;
